<h2 mat-dialog-title>Neue Liste hinzufügen</h2>

<mat-dialog-content class="dialog-content">

  <p class="intro">
    Welche Art von Liste soll dem Projekt
    <strong>{{ data.projektName }}</strong>
    hinzugefügt werden?
  </p>

  <div class="typ-liste" role="radiogroup" aria-label="Listentyp">

    <button type="button" class="typ-option" *ngFor="let t of typen" role="radio"
      [attr.aria-checked]="auswahl === t.typ" [class.aktiv]="auswahl === t.typ" (click)="waehle(t.typ)">

      <mat-icon class="typ-icon">{{ t.icon }}</mat-icon>

      <span class="typ-text">

        <span class="typ-titel">{{ t.titel }}</span>

        <span class="typ-sub">{{ t.beschreibung }}</span>

        <span class="typ-import" [class.typ-import-ki]="t.importZiel === 'inbetriebnahme'">
          <mat-icon inline>{{ t.importZiel === 'sps' ? 'table_view' : 'auto_awesome' }}</mat-icon>
          {{ t.importVerfahren }}
        </span>

      </span>

      <mat-icon class="haken" *ngIf="auswahl === t.typ">check_circle</mat-icon>

    </button>

  </div>

  <p class="hinweis" *ngIf="gewaehlt?.importZiel === 'sps'">
    <mat-icon>info_outline</mat-icon>
    „Weiter“ öffnet den SPS-Import. Die Spalten werden anhand der Überschriften
    erkannt, eine KI-Analyse ist nicht nötig.
  </p>

  <p class="hinweis" *ngIf="gewaehlt?.importZiel === 'inbetriebnahme'">
    <mat-icon>info_outline</mat-icon>
    „Weiter“ öffnet den bisherigen KI-gestützten Import. Der Listentyp wird
    dort aus der Excel-Datei erkannt.
  </p>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="abbrechen()">Abbrechen</button>
  <button mat-raised-button color="primary" type="button" [disabled]="!auswahl" (click)="weiter()">
    <mat-icon>arrow_forward</mat-icon>
    Weiter
  </button>
</mat-dialog-actions>
